// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"447":"4134d600","967":"f5f7954f"}[chunkId] + ".chunk.js";
};